import { createElement, useReducer } from 'react';
import { useDesignTokens, renderInlineCssVars } from '../../theme';
import { WindowShadeProps } from './types';

import { BaseWindowShade } from './BaseWindowShade';

export const WindowShade = ({ initialOpenSections, isAccordion, ...props }: WindowShadeProps) => {
  const [openSections, toggleSection] = useReducer(
    (prevState: readonly number[], sectionIndex: number) => {
      const prevIndex = prevState.indexOf(sectionIndex);
      if (prevIndex === -1) {
        return isAccordion ? [sectionIndex] : [...prevState, sectionIndex];
      } else {
        const nextState = prevState.slice();
        nextState.splice(prevIndex, 1);
        return nextState;
      }
    },
    initialOpenSections || []
  );

  const dt = useDesignTokens();
  const tokens = renderInlineCssVars(
    {
      'font-size-': dt.fontNova.size.h5,
      'font-weight-default': dt.fontNova.weight.default,
    },
    'windowshade'
  );

  return (
    <BaseWindowShade
      {...props}
      style={{ ...tokens, ...props.style }}
      openSections={props.openSections ?? openSections}
      onToggleSection={(sectionIndex) => {
        toggleSection(sectionIndex);
        props.onToggleSection?.(sectionIndex);
      }}
    />
  );
};

export function getUpdatedOpenSectionsOnToggle(
  openSections: number[],
  toggledIndex: number,
  isAccordion = false
) {
  if (isAccordion) {
    return [toggledIndex];
  }
  const updatedOpenSections = [...openSections];
  const targetIndex = openSections.indexOf(toggledIndex);
  if (targetIndex !== -1) {
    updatedOpenSections.splice(targetIndex, 1);
  } else {
    updatedOpenSections.push(toggledIndex);
  }
  return updatedOpenSections;
}

export function getUpdatedSectionsStateOnReorder<T>(
  sections: T[],
  openSections: number[],
  oldIndex: number,
  newIndex: number
) {
  const openSectionRefs = openSections.map((sectionIndex) => sections[sectionIndex]);

  const reorderedSections = [...sections];
  const removedSections = reorderedSections.splice(oldIndex, 1);
  reorderedSections.splice(newIndex, 0, removedSections[0]);

  const reorderedOpenSections = openSectionRefs.map((sectionRef) =>
    reorderedSections.indexOf(sectionRef)
  );

  return { sections: reorderedSections, openSections: reorderedOpenSections };
}
